import { GET_PROFILE_DETAILS, SET_PROFILE_DETAILS, SET_USER_PROFILE_TYPE, DELETE_USER } from "./types";

export const getProfileDetails = () => ({
    type: GET_PROFILE_DETAILS,
});

export const setProfileDetails = (payload) => ({
    type: SET_PROFILE_DETAILS,
    payload,
});

export const setUserProfileType = (payload) => ({
    type: SET_USER_PROFILE_TYPE,
    payload,
});
export const deleteUserAPI = (payload) => ({
    type: DELETE_USER,
    payload,
});
